import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy text-white" data-id="element-18" data-mp="32ovvcp86ejhi">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-19" data-mp="36p6bgupomqa3">
        <div data-id="element-20" data-mp="3ueik9th3kwbv">
          <Logo variant="light" data-id="element-21" data-mp="3uesbtlhsjbjo" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/75" data-id="element-22" data-mp="3uftmhouw9w0v">
            A consultative partner helping practices compare, select, train on,
            and implement therapeutic technologies across the United States.
          </p>
        </div>
        <div data-id="element-23" data-mp="3qcniyoz62iy3">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-24" data-mp="3qc41f9dfhwkl">
            Explore
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm text-white/80" data-id="element-25" data-mp="2a19v9qy5pwze">
            <li data-id="element-26" data-mp="2ez1l8ff8r90y">
              <Link to="/#products" className="transition-colors hover:text-teal-light" data-id="element-27" data-mp="2ezl3xycpu1g1">
                Products
              </Link>
            </li>
            <li data-id="element-28" data-mp="3gca7d7ohu1db">
              <Link to="/#product-of-the-month" className="transition-colors hover:text-teal-light" data-id="element-29" data-mp="3gcjw6rxsy2hf">
                Product of the Month
              </Link>
            </li>
            <li data-id="element-30" data-mp="82qrjqil5pso">
              <Link to="/#concierge" className="transition-colors hover:text-teal-light" data-id="element-31" data-mp="828ni7pom7a7">
                Concierge Suite
              </Link>
            </li>
            <li data-id="element-32" data-mp="ht3d9m24zp0e">
              <Link to="/#used-equipment" className="transition-colors hover:text-teal-light" data-id="element-33" data-mp="hrihxu80021h">
                Used Equipment
              </Link>
            </li>
            <li data-id="element-34" data-mp="qu1jmb01s8m5">
              <Link to="/about" className="transition-colors hover:text-teal-light" data-id="element-35" data-mp="qrfboa98vr3e">
                About
              </Link>
            </li>
            <li data-id="element-36" data-mp="twxqz8ok588s">
              <Link to="/contact" className="transition-colors hover:text-teal-light" data-id="element-37" data-mp="tta2inxyzc0x">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div data-id="element-38" data-mp="18kiw184zthjc">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-39" data-mp="18k92xboniu9f">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-white/80" data-id="element-40" data-mp="1clckc2mckycr">
            <li className="font-medium text-white" data-id="element-41" data-mp="1hjw7258rme66">{CONTACT.name}</li>
            <li data-id="element-42" data-mp="1mjsao3djw3l7">
              <a href={CONTACT.phoneHref} className="flex items-center gap-2.5 transition-colors hover:text-teal-light" data-id="element-43" data-mp="1mj8vuvj75vbe">
                <PhoneIcon className="h-4 w-4 text-teal-light" data-id="element-44" data-mp="1rgiqqqpcuz6m" />
                {CONTACT.phone}
              </a>
            </li>
            <li data-id="element-45" data-mp="3t9q59xx59crg">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 break-all transition-colors hover:text-teal-light" data-id="element-46" data-mp="3tb9l5new1lsp">
                <MailIcon className="h-4 w-4 shrink-0 text-teal-light" data-id="element-47" data-mp="25o57sdb3bha1" />
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-48" data-mp="21n1v1zoca1d1">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-light" data-id="element-49" data-mp="1wo8okr7gzamd" />
              <span data-id="element-50" data-mp="2tdpth3ymosn0">{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15" data-id="element-51" data-mp="2pcea3g6cl3n9">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-52" data-mp="2pcw5kal6rdu4">
          <p data-id="element-53" data-mp="2fegol0fvhkyc">
            © {new Date().getFullYear()} JAG Medical Solutions. All rights
            reserved.
          </p>
          <p data-id="element-54" data-mp="18yecwcyvzs3p">Therapeutic modalities, matched to your practice.</p>
        </div>
      </div>
    </footer>;
}